function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="logo">
          <p className="first-company">株式会社MydoMind</p>
          <p className="second-company">
            （事務局）合同会社 観光ビジネス研究会
          </p>
        </div>

        <div className="hosoku">協力 枚方市、枚方文化観光協会</div>
      </footer>
      <footer className="copyright">&copy; MydoMind,INC. 2023. All rights reserved.</footer>
    </>
  );
}

export default Footer;
